/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Buyer_Email_InvalidInputs */

const vi_einvoice_buyer_email_invalid = /** @type {(inputs: Einvoice_Buyer_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email nhận hóa đơn chưa đúng định dạng, ví dụ ketoan@congty.vn`)
};

/**

* @param {Einvoice_Buyer_Email_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_buyer_email_invalid = /** @type {((inputs?: Einvoice_Buyer_Email_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Buyer_Email_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_buyer_email_invalid(inputs)
});